// extracted by mini-css-extract-plugin
export default {"CourseMenuContainer":"AddCourse_CourseMenuContainer__771in","SearchBar":"AddCourse_SearchBar__Tyclq","SectionHeader":"AddCourse_SectionHeader__Sn+0B"};